export const STATUS_LABEL_MAP = {
  overdue: "Overdue",
  done: "Completed",
  in_progress: "In Progress",
} as const;

export const ALL_STATUSES = ["overdue", "done", "in_progress"] as const;
